import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FormlyModule } from '@ngx-formly/core';

import { DirectivesModule } from '@directives/directives.module';

import { TaAssetSelectComponent } from './ta-asset-select.component';

import { RequiredValidator } from '../ta-validators';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
    declarations: [TaAssetSelectComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DirectivesModule,
        NgSelectModule,
        FormlyModule.forChild({
            types: [
                {
                    name: 'ta-asset-select',
                    component: TaAssetSelectComponent,
                    defaultOptions: {
                        validators: {
                            required: RequiredValidator,
                        }
                    }
                }
            ]
        })
    ]
})
export class TaFormlyAssetSelectModule { }
